import { Suspense, useEffect, useRef, useState } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import { LandingFooter } from '../IndexPage/sorteeLanding/components/LandingFooter'
import { ArrowRightIcon, LandingIcon } from '../IndexPage/sorteeLanding/components/icons'
import '../IndexPage/sorteeLanding/styles/sortee-landing-scope.css'
import styles from './MarketingPages.module.css'

export function MarketingLayout() {
  const [menuOpen, setMenuOpen] = useState(false)
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])
  const toggle = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    const targets = [
      document.documentElement,
      document.body,
      document.getElementById('root'),
    ]
    targets.forEach((element) => element?.classList.add('sortee-landing-active'))
    return () =>
      targets.forEach((element) => element?.classList.remove('sortee-landing-active'))
  }, [])
  useEffect(() => {
    function close(event: KeyboardEvent) {
      if (event.key === 'Escape' && menuOpen) {
        setMenuOpen(false)
        toggle.current?.focus()
      }
    }
    document.addEventListener('keydown', close)
    return () => document.removeEventListener('keydown', close)
  }, [menuOpen])
  return (
    <div className={styles.page}>
      <a href="#conteudo" className={styles.skipLink}>
        Pular para o conteúdo
      </a>
      <header className={styles.header}>
        <div className={styles.container}>
          <Link to="/" aria-label="Sortee, página inicial" className={styles.logo}>
            <img src="/logo/sortee.png" alt="Logo Sortee" width="2089" height="753" />
          </Link>
          <nav className={styles.desktopNav} aria-label="Navegação principal">
            <NavLink to="/recursos">Recursos</NavLink>
            <NavLink to="/como-funciona">Como funciona</NavLink>
            <Link to="/#faq">Dúvidas frequentes</Link>
          </nav>
          <div className={styles.headerActions}>
            <Link to="/login" className={styles.login}>
              Entrar
            </Link>
            <Link to="/cadastro" className={styles.navCta}>
              Criar conta <ArrowRightIcon />
            </Link>
            <button
              ref={toggle}
              type="button"
              className={styles.menuToggle}
              aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
              aria-expanded={menuOpen}
              aria-controls="resource-navigation"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <LandingIcon
                name={menuOpen ? 'plus' : 'menu'}
                className={menuOpen ? styles.closeIcon : undefined}
              />
            </button>
          </div>
        </div>
        <nav
          id="resource-navigation"
          aria-label="Navegação mobile"
          className={styles.mobileNav}
          data-open={menuOpen}
          aria-hidden={!menuOpen}
          inert={!menuOpen}
        >
          <div>
            <Link to="/recursos" onClick={() => setMenuOpen(false)}>
              Recursos <ArrowRightIcon />
            </Link>
            <Link to="/como-funciona" onClick={() => setMenuOpen(false)}>
              Como funciona <ArrowRightIcon />
            </Link>
            <Link to="/#faq" onClick={() => setMenuOpen(false)}>
              Dúvidas frequentes <ArrowRightIcon />
            </Link>
            <Link to="/login" onClick={() => setMenuOpen(false)}>
              Entrar na minha conta <ArrowRightIcon />
            </Link>
          </div>
        </nav>
      </header>
      <main id="conteudo" tabIndex={-1}>
        <Suspense
          fallback={
            <div className={`${styles.container} ${styles.loading}`} role="status">
              Carregando conteúdo…
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
      <LandingFooter />
    </div>
  )
}
